export type StepKey =
  | 'contract'
  | 'clientDataReview'
  | 'midsInformation'
  | 'services'
  | 'credentials'
  | 'review'
  | 'fdValidation';

export type StepStatus = 'pending' | 'inProgress' | 'completed' ;

export interface StepState {
  step: StepKey;
  status: StepStatus;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface OnboardingStatusResponse {
  onboardingId: number;
  fdClientId: string;
  createdBy: string;
  steps: StepState[];
}


export const STEP_ORDER: StepKey[] = [
  'contract',
  'clientDataReview',
  'midsInformation',
  'services',
  'credentials',
  'review',
  'fdValidation',
];

export const STEP_LABELS: Record<StepKey, { title: string; subtitle?: string }> = {
  contract: { title: 'Step 1: Contract Signed' },
  clientDataReview: { title: "Step 2: Client's Review", subtitle: 'Click here to review your data' },
  midsInformation: { title: 'Step 3: MID Information',subtitle: 'Click here to add MID data' },
  services: { title: 'Step 4: Service Settings',subtitle: 'Click here to configure MID services' },
  credentials: { title: 'Step 5: Credentials', subtitle: 'Click here to see credentials information' },
  review: { title: 'Step 6: Review & Submit'},
  fdValidation: { title: 'Step 7: FD Review',subtitle: 'Click here to see FD review' },
};

export const STEP_PATH: Record<StepKey, string> = {
  contract: 'contract-data',
  clientDataReview: 'client-data-review',
  midsInformation: 'mids',
  services: 'services-settings',
  credentials: 'credentials',
  review: 'onboarding-review',
  fdValidation: 'fd-review',
};


export interface ApiStepperItem {
  id: number;
  step: string;
  status:'inProgress' |'pending' | 'completed';
  onboardingId: number;
  createdAt: string;
  updatedAt: string;
  stepName: string;
};

export interface ApiStepperResponse {
  message: string;
  result: ApiStepperItem[];
};

export const STEP_FROM_NUMBER: Record<number, StepKey> = {
  1: 'contract',
  2: 'clientDataReview',
  3: 'midsInformation',
  4: 'services',
  5: 'credentials',
  6: 'review',
  7: 'fdValidation',
};

export const NUMBER_FROM_STEP: Record<StepKey, number> = {
  contract: 1,
  clientDataReview: 2,
  midsInformation: 3,
  services: 4,
  credentials: 5,
  review: 6,
  fdValidation: 7,
};
